// Review ID,Submission date,Initial publish date,Moderation status,Review title,Review text,Rating,Ratings-only review,Product ID,Product name,Product status,Product description,Product image URL,Product brand name,Category ID,Category name,Top level category,Top level category ID,Category hierarchy,Staff badge,Expert badge,Top contributor,Character count,# Comments,# Approved comments,# Pending comments,# Rejected comments,# Expired comments,# Inappropriate votes,# Not helpful votes,# Helpful votes,Would recommend,Locale,Display code,Product page URL,Campaign ID,Featured review,Incentivized review,# Photos,# Videos,# Responses,Photo 1,Photo 2,Photo 3,Photo 4,Photo 5,Client response 1,Response department 1,Response name 1,UPC,PRODUCT_PAGE_URL,AVAILABILITY,NAME,IMAGE_URL,CREATED_ON_SUBMIT,VerifiedPurchaser,GTIN14,IncentivizedReview,Value,Quality,Age,Gender
// Debug flag - set to true to enable console logs, false to disable
const DEBUG = false;

// Helper function for conditional logging
function debugLog(...args) {
  if (DEBUG) {
    console.log(...args);
  }
}

// Global variable to store product list data
let globalProductList = [];

document.addEventListener('DOMContentLoaded', function() {
  // Initialize the custom reviews section
  initCustomReviews();
  
  // Parse product list data once for better performance
  const productListData = document.querySelector('.t4s-custom-reviews-list')?.getAttribute('data-t4s-product-list-data');
  if (productListData) {
    try {
      globalProductList = JSON.parse(productListData);
      debugLog('Product list loaded:', globalProductList.length, 'products');
    } catch (e) {
      console.error('Error parsing product list data:', e);
    }
  }

  function initCustomReviews() {
    const reviewsContainer = document.querySelector('.t4s-custom-reviews-list');
    if (!reviewsContainer) return;
    // clear cache data
    window.reviewsData=null;
    
    // Get the CSV URL from the data attribute
    const customCsvUrl = reviewsContainer.getAttribute('data-csv-url');
    // Base reviews URL
    const baseCsvUrl = 'https://cdn.shopify.com/s/files/1/0624/8729/8290/files/utf8_merged_reviews.csv?v=1750147422';
    
    if (!customCsvUrl && !baseCsvUrl) {
      console.error('No CSV URL provided for reviews'); // Keep error logs as they are important
      return;
    }
    
    // Show loading indicator
    const loadingIndicator = document.querySelector('.t4s-reviews-loading');
    if (loadingIndicator) {
      loadingIndicator.style.display = 'flex';
    }
    
    // Hide empty state
    const emptyState = document.querySelector('.t4s-reviews-empty');
    if (emptyState) {
      emptyState.style.display = 'none';
    }
    
    // Function to fetch and parse a CSV file
    const fetchCsv = async (url) => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch ${url}: ${response.status} ${response.statusText}`);
        }
        const csvData = await response.text();
        return parseCSV(csvData);
      } catch (error) {
        console.error(`Error fetching CSV from ${url}:`, error);
        return [];
      }
    };
    
    // Fetch both CSV files and merge them
    Promise.all([
      fetchCsv(baseCsvUrl),
      customCsvUrl ? fetchCsv(customCsvUrl) : Promise.resolve([])
    ])
      .then(([baseData, customData]) => {
        debugLog('Base data count:', baseData.length);
        debugLog('Custom data count:', customData.length);
        
        // Merge the data arrays
        let data = [...baseData, ...customData];
        
        // Process custom data first, then base data, with custom taking precedence
        const reviewMap = new Map();

        // First add all base data
        baseData.forEach(review => {
          const reviewId = review['Review ID'];
          if (reviewId && !reviewMap.has(reviewId)) {
            reviewMap.set(reviewId, review);
          }
        });

        // Then add/overwrite with custom data
        customData.forEach(review => {
          const reviewId = review['Review ID'];
          if (reviewId) {
            reviewMap.set(reviewId, review);
          }
        });

                  
        data = Array.from(reviewMap.values());
        // Check if we need to calculate average rating and review count
        updateReviewStats(data);
        
        if (data && data.length > 0) {
          // First deduplicate reviews with same title and text, keeping the one with longer customer name
          const uniqueReviewsMap = new Map();
          
          data.forEach(review => {
            const title = (review['Review title'] || '').toLowerCase().trim();
            const text = (review['Review text'] || '').toLowerCase().trim();
            const key = `${title}|||${text}`;
            
            if (!key.includes('null') && title && text) {
              const currentCustomerName = (review['Customer name'] || review['Customer nam'] || '').trim();
              const existingReview = uniqueReviewsMap.get(key);
              
              if (!existingReview || 
                  (existingReview && currentCustomerName.length > (existingReview['Customer name'] || existingReview['Customer nam'] || '').trim().length)) {
                uniqueReviewsMap.set(key, review);
              }
            }
          });
          
          // Update data with deduplicated reviews
          data = Array.from(uniqueReviewsMap.values());


          let productIds = [];

          // Store all reviews in a global variable for filtering, excluding empty reviews
           data= data.filter(review => {
            const reviewTitle = review['Review title'] || '';
            const reviewText = review['Review text'] || '';
            productIds.push(review['Product ID']);
            debugLog('Review:', reviewText, reviewTitle)
            return reviewTitle.trim() !== '' && reviewText.trim() !== '' && reviewTitle.trim().toLowerCase()!="null" && reviewText.trim().toLowerCase()!="null";
          });

          window.allReviews=data;
          window.allReviewsProductIds=productIds;
          // Set up event listeners for filtering
          setupFilters();
        } else {
          // Show empty state
          if (emptyState) {
            emptyState.style.display = 'flex';
          }
        }
        
        // Hide loading indicator
        if (loadingIndicator) {
          loadingIndicator.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Error loading reviews:', error); // Keep error logs
        
        // Hide loading indicator
        if (loadingIndicator) {
          loadingIndicator.style.display = 'none';
        }
        
        // Show empty state
        if (emptyState) {
          emptyState.style.display = 'flex';
        }
      });
  }
  
  // Parse CSV data into an array of objects using Papa Parse
  function parseCSV(csvText) {
    debugLog('Using Papa Parse to parse CSV data');
    if (!csvText || csvText.trim() === '') return [];
    
    // Check if Papa Parse is available
    if (typeof Papa === 'undefined') {
      console.error('Papa Parse is not loaded. Make sure papaparse.min.js is properly included.'); // Keep error logs
      return [];
    }
    let csvTextArray=[csvText]
    if (csvText.includes('file-divider------\n')) {
      csvTextArray=csvText.split('file-divider------\n');
    }
    let reviewData=[]

    csvTextArray.forEach(csvText => { 
      // Use Papa Parse to parse the CSV
      const result = Papa.parse(csvText, {
        header: true,          // First row is headers
        skipEmptyLines: true,  // Skip empty rows
        dynamicTyping: false,  // Keep everything as strings
        trimHeaders: true,     // Trim whitespace from headers
        transform: (value) => value.trim() // Trim all values
      });
      reviewData=reviewData.concat(result.data);
    })
    debugLog('Papa Parse processed', reviewData.length, 'rows');
    return reviewData; // Return the parsed data
  }
  
  // Calculate and update average rating and review count if needed
  function updateReviewStats(reviewsData,productId) {
    if(!window.reviewsData&&reviewsData&&reviewsData.length>0){
      window.reviewsData=reviewsData;
    }
    reviewsData=window.reviewsData;
    // Get current values from the page
    const averageRatingElement = document.querySelector('.t4s-rating-value');
    const reviewsCountElements = document.querySelectorAll('.t4s-reviews-count, .t4s-reviews-count-number');
    
    // Initialize star rating counts
    const starCounts = {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0
    };
    
    let reviewsCount=0;
    let totalRating = 0;
    let validRatings = 0;
    
    // Count ratings by star level
    reviewsData.forEach(review => {
      if(productId&&productId!='all'){
        if(review['Product ID']!=productId){
          return;
        }
      }
      reviewsCount++;
      const rating = parseInt(review['Rating']) || 0;
      if (rating > 0 && rating <= 5) {
        starCounts[rating]++;
        totalRating += rating;
        validRatings++;
      }
    });
    
    // Calculate average rating
    const averageRating = validRatings > 0 ? (totalRating / validRatings).toFixed(1) : '0';
    
    // Check if we need to calculate the average rating
    if (averageRatingElement && averageRatingElement.dataset.defaultRating === '0') {
      // Update all instances of average rating on the page
      document.querySelectorAll('.t4s-rating-value, .t4s-summary-rating').forEach(el => {
        el.textContent = averageRating;
      });
    }
    
    // Check if we need to update the review count
    reviewsCountElements.forEach(element => {
      if (element && element.dataset.defaultReviewsCount === '0') {
        // Update with actual count
        element.textContent = reviewsCount;
      }
    });
    
    // Update rating bars if needed
    for (let i = 5; i >= 1; i--) {
      const ratingBar = document.querySelector(`.t4s-rating-bar[data-stars="${i}"]`);
      if (ratingBar) {
        const countElement = ratingBar.querySelector('.t4s-count');
        const barElement = ratingBar.querySelector('.t4s-bar');
        
        // Check if we should update the count
        const countSettingId = `${i.toString().toLowerCase()}_star_count`;
        const countSetting = document.querySelector(`meta[name="${countSettingId}"]`);
        const defaultCount = countSetting ? countSetting.getAttribute('content') : '0';
        
        // Only update if the count is the default (0)
        if (countElement && defaultCount === '0') {
          countElement.textContent = starCounts[i];
        }
        
        // Check if we should update the percentage
        const percentSettingId = `${i.toString().toLowerCase()}_star_percent`;
        const percentSetting = document.querySelector(`meta[name="${percentSettingId}"]`);
        const defaultPercent = percentSetting ? percentSetting.getAttribute('content') : '0';
        
        // Update the bar width if the default is 0%
        if (barElement && defaultPercent === '0') {
          const percent = validRatings > 0 ? Math.round((starCounts[i] / validRatings) * 100) : 0;
          barElement.style.width = `${percent}%`;
        }
      }
    }
  }

  // Generate rating stars based on rating value using SVG images
  function generateRatingStars(rating) {
    const ratingValue = parseInt(rating) || 5;
    let starsHtml = '';
    
    // Get the asset URLs from the DOM
    const starIconUrl = document.querySelector('meta[name="star-icon-url"]')?.getAttribute('content') || '/assets/rating-star.svg';
    const emptyStarIconUrl = document.querySelector('meta[name="empty-star-icon-url"]')?.getAttribute('content') || '/assets/rating-star-empty.svg';
    
    // Add filled stars
    for (let i = 1; i <= ratingValue; i++) {
      starsHtml += `<img src="${starIconUrl}" alt="Star" width="16" height="16" class="t4s-star-icon">`;
    }
    
    // Add empty stars
    for (let i = ratingValue + 1; i <= 5; i++) {
      starsHtml += `<img src="${emptyStarIconUrl}" alt="Empty Star" width="16" height="16" class="t4s-star-icon empty">`;
    }
    
    return starsHtml;
  }
  // Format date to human-readable format (e.g., "yesterday", "2 days ago", or "Month Day, Year")
  function formatDate(dateString) {
    if (!dateString) return '';
    
    let date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // If date is invalid, try to parse it as MM/DD/YYYY
      const parts = dateString.split('/');
      if (parts.length === 3) {
        const month = parseInt(parts[0]) - 1;
        const day = parseInt(parts[1]);
        const year = parseInt(parts[2]);
        date = new Date(year, month, day);
        if (isNaN(date.getTime())) {
          return dateString; // Return original if still invalid
        }
      } else {
        return dateString; // Return original if format is unknown
      }
    }
    
    const now = new Date();
    const diffTime = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    // Return human-readable format for recent dates
    if (diffDays === 0) {
      // Check if it's today
      if (now.getDate() === date.getDate() && 
          now.getMonth() === date.getMonth() && 
          now.getFullYear() === date.getFullYear()) {
        return 'today';
      }
    } else if (diffDays === 1) {
      return 'yesterday';
    } else if (diffDays < 7) {
      return `${diffDays} days ago`;
    } else if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
    } else if (diffDays < 90) {
      const months = Math.floor(diffDays / 30);
      return months === 1 ? '1 month ago' : `${months} months ago`;
    }
    
    // For older dates, return the full date
    return date.toLocaleDateString('en-US', { 
      month: 'long', 
      day: 'numeric', 
      year: 'numeric' 
    });
  }

  // Display reviews in the container
  function displayReviews(reviewsArray, page = 1, perPage = 5) {
    debugLog("displayReviews", reviewsArray.length)
    const reviewsContainer = document.querySelector('.t4s-custom-reviews-list');
    if (!reviewsContainer) return;
    
    // Get the template
    const template = document.getElementById('t4s-review-template');
    if (!template) {
      console.error('Review template not found');
      return;
    }
    
    // Remove any existing reviews
    const existingReviews = reviewsContainer.querySelectorAll('.t4s-review-item');
    existingReviews.forEach(item => item.remove());
    
    // Hide loading indicator
    const loadingIndicator = reviewsContainer.querySelector('.t4s-reviews-loading');
    if (loadingIndicator) {
      loadingIndicator.style.display = 'none';
    }
    
    // Calculate start and end indices for current page
    const startIndex = (page - 1) * perPage;
    const endIndex = Math.min(startIndex + perPage, reviewsArray.length);
    
    // Get reviews for current page
    const currentPageReviews = reviewsArray.slice(startIndex, endIndex);
    
    if (currentPageReviews.length === 0) {
      // Show empty state
      const emptyState = reviewsContainer.querySelector('.t4s-reviews-empty');
      if (emptyState) {
        emptyState.style.display = 'block';
      }
      return;
    }
    
    // Hide empty state if it's visible
    const emptyState = reviewsContainer.querySelector('.t4s-reviews-empty');
    if (emptyState) {
      emptyState.style.display = 'none';
    }
    
    // Create and append review elements
    currentPageReviews.forEach(review => {
      // Clone the template
      const reviewElement = template.content.cloneNode(true).querySelector('.t4s-review-item');
      
      // Format the review content
      const reviewDate = formatDate(review['Initial publish date'] || review['CREATED_ON_SUBMIT']);
      const reviewName = review['Customer name']|| review['Customer nam']|| 'Anonymous';
      const reviewRating = review['Rating'] || '5';
      const reviewTitle = review['Review title'] || 'Review';
      const reviewText = review['Review text'] || '';
      
      // Get review images if available
      const reviewImages = [];
      for (let i = 1; i <= 5; i++) {
        const photoKey = `Photo ${i}`;
        if (review[photoKey] && review[photoKey].trim() !== '') {
          reviewImages.push(review[photoKey]);
        }
      }
      
      // Set the review content
      reviewElement.querySelector('.t4s-review-name').textContent = reviewName;
      reviewElement.querySelector('.t4s-review-date').textContent = reviewDate;
      reviewElement.querySelector('.t4s-stars').innerHTML = generateRatingStars(reviewRating);
      
      // Add product name from CSV data with link to product page
      const productId = review['Product ID'] || '';
      const productName = review['Product name'] || '';
      const productNameElement = reviewElement.querySelector('.t4s-review-product-name');
      
      if (productNameElement && (productName || productId)) {
        // Try to find product in the global product list
        let productInfo = null;
        
        if (productId && globalProductList.length > 0) {
          productInfo = globalProductList.find(p => p.id == productId);
        }
        
        // Clear any existing content
        while (productNameElement.firstChild) {
          productNameElement.removeChild(productNameElement.firstChild);
        }
        
        // If we found the product in our JSON data, use that info
        if (productInfo) {
          const productLink = document.createElement('a');
          productLink.href = productInfo.url;
          productLink.textContent = productInfo.title;
          productLink.className = 't4s-product-link';
          productNameElement.appendChild(productLink);
        } else if (productName) {
          // Fallback to the CSV product name
          productNameElement.textContent = productName;
        }
      }
      
      reviewElement.querySelector('.t4s-review-title').textContent = reviewTitle;
      reviewElement.querySelector('.t4s-review-text').textContent = reviewText;
      
      // Add review images if available
      const reviewImagesContainer = reviewElement.querySelector('.t4s-review-images');
      if (reviewImagesContainer && reviewImages.length > 0) {
        // Make sure the container is visible
        reviewImagesContainer.style.display = 'flex';
        
        // Add each image to the container
        reviewImages.forEach(imageUrlStr => {
          // Only add if the URL is valid
          if (imageUrlStr && imageUrlStr.trim() !== '') {
            imageUrlStr.split(',').forEach(imageUrl => { 

            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = 'Review image';
            img.className = 't4s-review-image';
            img.loading = 'lazy'; // Add lazy loading for better performance
            
            // Add click event to open image in a larger view
            img.addEventListener('click', function() {
              const fullImg = document.createElement('img');
              fullImg.src = this.src;
              fullImg.alt = this.alt;
              fullImg.style.maxWidth = '100%';
              fullImg.style.maxHeight = '90vh';
              
              const modal = document.createElement('div');
              modal.style.position = 'fixed';
              modal.style.top = '0';
              modal.style.left = '0';
              modal.style.width = '100%';
              modal.style.height = '100%';
              modal.style.backgroundColor = 'rgba(0,0,0,0.8)';
              modal.style.display = 'flex';
              modal.style.alignItems = 'center';
              modal.style.justifyContent = 'center';
              modal.style.zIndex = '9999';
              modal.style.padding = '20px';
              modal.appendChild(fullImg);
              
              modal.addEventListener('click', function() {
                document.body.removeChild(modal);
              });
              
              document.body.appendChild(modal);
            });
            
            reviewImagesContainer.appendChild(img);
            });
          }
        });
      } else if (reviewImagesContainer) {
        // Hide the container if no images
        reviewImagesContainer.style.display = 'none';
      }
      
      // Set up share button functionality
      const shareContainer = reviewElement.querySelector('.t4s-review-main-content .t4s-review-footer .t4s-share-container');
      const shareButton = shareContainer ? shareContainer.querySelector('.t4s-share-btn') : null;
      
      if (shareButton && shareContainer) {
        // Get the social share buttons
        const facebookBtn = shareContainer.querySelector('.t4s-facebook-btn');
        const twitterBtn = shareContainer.querySelector('.t4s-twitter-btn');
        const linkedinBtn = shareContainer.querySelector('.t4s-linkedin-btn');
        
        // Create share URLs
        const pageUrl = window.location.href;
        const shareText = `${reviewTitle} - ${reviewText}`;
        
        // Set up share URLs
        if (facebookBtn) {
          facebookBtn.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}&quote=${encodeURIComponent(shareText)}`;
        }
        
        if (twitterBtn) {
          twitterBtn.href = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(pageUrl)}`;
        }
        
        if (linkedinBtn) {
          linkedinBtn.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageUrl)}`;
        }
        
        // Toggle social buttons on share button click
        shareButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          shareContainer.classList.toggle('active');
        });
        
        // Close social buttons when clicking outside
        document.addEventListener('click', function(e) {
          if (!shareContainer.contains(e.target)) {
            shareContainer.classList.remove('active');
          }
        });
      }
      
      // Append the review to the container
      reviewsContainer.appendChild(reviewElement);
    });
        // Update pagination with the same per page value
    setupPagination(reviewsArray.length, getOptimalPerPage(reviewsArray.length));
    // Update active page in pagination
    updateActivePage(page);
  }

  // Set up event listeners for filtering
  function setupFilters(hideSelectedProductInDropdown=false) {
    const productFilterButtons = document.querySelectorAll('.t4s-filter-btn');
    const ratingFilter = document.getElementById('rating-filter');
    const sortFilter = document.getElementById('sort-filter');
    const mediaFilter = document.getElementById('media-filter');
    const productListFilter = document.getElementById('product-list-filter');
    const resetFilter = document.querySelector('.t4s-filter-reset');
    
    // Setup custom dropdowns
    setupCustomDropdown('sort-filter-wrapper', 'sort-filter-display', 'sort-filter-dropdown', 'sort-filter');
    setupCustomDropdown('media-filter-wrapper', 'media-filter-display', 'media-filter-dropdown', 'media-filter');
    setupCustomDropdown('rating-filter-wrapper', 'rating-filter-display', 'rating-filter-dropdown', 'rating-filter');
    
    // Setup product list filter dropdown if it exists
    if (document.getElementById('product-list-filter-wrapper')) {
      setupCustomDropdown('product-list-filter-wrapper', 'product-list-filter-display', 'product-list-filter-dropdown', 'product-list-filter');
    }
    
    // Product filter buttons (legacy, kept for backward compatibility)
    const dropdownContainer = document.getElementById('product-list-filter-dropdown');
    if (productFilterButtons.length > 0) {
      productFilterButtons.forEach(button => {
        button.addEventListener('click', function() {
          // Toggle active class
          productFilterButtons.forEach(btn => btn.classList.remove('active'));
          this.classList.add('active');
          
          // Reset product list filter if it exists
          if (productListFilter) {
            productListFilter.value = 'all';
            const display = document.getElementById('product-list-filter-display');
            if (display) {
              display.querySelector('.t4s-select-display-text').textContent = productListFilter.options[0].textContent;
            }
          }
          applyAllFilters();
        });

          if (hideSelectedProductInDropdown){
          // Get filter value and apply filters
          const productFilter = button.getAttribute('data-filter');
          
          // Hide the selected product in the product list filter
          if (dropdownContainer) {
            // Hide the currently selected product in the list
            if (productFilter && productFilter !== 'all') {
              const optionToHide = dropdownContainer.querySelector(`.t4s-dropdown-option[data-value="${productFilter}"]`);
              if (optionToHide) {
                optionToHide.style.display = 'none';
                console.log('Hiding option:', optionToHide);
              } else {
                console.log('Option not found for:', productFilter);
              }
            }
          }
        }
      });
      
    }

    if (dropdownContainer){
      // set hidden attribute to the product option not in the window.allReviews ["Product ID"]
      const options = dropdownContainer.querySelectorAll('.t4s-dropdown-option');

      options.forEach(option => {
        if (!window.allReviewsProductIds.includes(option.getAttribute('data-value'))&&option.getAttribute('data-value') !== 'all') {
          option.style.display = 'none';
         } 
      });
    }
    
    // Media filter change handler
    if (mediaFilter) {
      mediaFilter.addEventListener('change', function() {
        applyAllFilters();
      });
    }
    
    // Rating filter change handler
    if (ratingFilter) {
      ratingFilter.addEventListener('change', function() {
        applyAllFilters();
      });
    }
    
    // Sort filter change handler
    if (sortFilter) {
      sortFilter.addEventListener('change', function() {
        applyAllFilters();
      });
    }
    
    // Product list filter change handler
    if (productListFilter) {
      productListFilter.addEventListener('change', function() {
        // If a product is selected from the list, deactivate any active product filter buttons
        if (this.value !== 'all' && productFilterButtons.length > 0) {
          productFilterButtons.forEach(btn => btn.classList.remove('active'));
        }
        applyAllFilters();
      });
    }
    
    // Helper function to get all current filter values and apply them
    function applyAllFilters() {
      const selectedProduct = getActiveProductFilter();
      const selectedRating = ratingFilter ? ratingFilter.value : 'all';
      const selectedMedia = mediaFilter ? mediaFilter.value : 'all';
      const selectedSort = sortFilter ? sortFilter.value : 'all';
      
      applyFilters(selectedProduct, selectedRating, selectedMedia, selectedSort);
      
      // Update URL with current filter state
      updateUrlWithFilters(selectedProduct, selectedRating, selectedMedia, selectedSort);
    }
    applyAllFilters();
  }

  // Update URL with current filter state
  function updateUrlWithFilters(productFilter, ratingFilter, mediaFilter, sortFilter) {
    // This is a placeholder for URL update logic if needed
    // You can implement URL updates here to maintain filter state on page refresh
  }
  
  // Apply filters to reviews
  function applyFilters(productFilter, ratingFilter, mediaFilter = 'all', sortFilter = 'all') {
    if(sortFilter=='all'){
      sortFilter='newest'
    }
    if (!window.allReviews) return;
    
    let filteredReviews = Object.values(window.allReviews);
    
    // Apply product filter
    if (productFilter && productFilter !== 'all') {
      filteredReviews = filteredReviews.filter(review => {
        return review['Product ID'] === productFilter;
      });
      updateReviewStats(null,productFilter);
    }
    // for reviews stats update
    if(!productFilter||productFilter=='all'){
      updateReviewStats(null,null);
    }
    
    // Apply rating filter
    if (ratingFilter && ratingFilter !== 'all') {
      const rating = parseInt(ratingFilter);
      filteredReviews = filteredReviews.filter(review => {
        return parseInt(review['Rating']) === rating;
      });
    }
    
    // Apply media filter (with images, with videos)
    if (mediaFilter && mediaFilter !== 'all') {
      if (mediaFilter === 'with-images') {
        filteredReviews = filteredReviews.filter(review => {
          return review['Photo 1'] && review['Photo 1'].trim() !== '' && review['Photo 1'].trim().toLowerCase() !== 'null';
        });
      } else if (mediaFilter === 'with-videos') {
        filteredReviews = filteredReviews.filter(review => {
          return review['Videos'] && review['Videos'].trim() !== '';
        });
      }
    }
    
    // Apply sort filter
    if (sortFilter && sortFilter !== 'all') {
      switch(sortFilter) {
        case 'newest':
          filteredReviews.sort((a, b) => {
            return new Date(b['Initial publish date']) - new Date(a['Initial publish date']);
          });
          break;
        case 'oldest':
          filteredReviews.sort((a, b) => {
            return new Date(a['Initial publish date']) - new Date(b['Initial publish date']);
          });
          break;
        case 'highest':
          filteredReviews.sort((a, b) => {
            return parseInt(b['Rating']) - parseInt(a['Rating']);
          });
          break;
        case 'lowest':
          filteredReviews.sort((a, b) => {
            return parseInt(a['Rating']) - parseInt(b['Rating']);
          });
          break;
      }
    }
    
    // Store the filtered reviews for pagination access
    window.currentFilteredReviews = filteredReviews;
    
    // Determine optimal reviews per page based on the filtered count
    const optimalPerPage = getOptimalPerPage(filteredReviews.length);
    
    // Store current page globally
    window.currentPage = 1;
    
    // Display filtered reviews with the optimal per page count
    displayReviews(filteredReviews, window.currentPage, optimalPerPage);
  }

  // Dynamically determine the optimal number of reviews per page based on screen size
  function getOptimalPerPage(totalReviews) {
    // Check if the screen width is less than 768px (mobile)
    if (window.innerWidth < 768) {
      return 6; // 6 reviews per page on mobile
    } else {
      return 10; // 10 reviews per page on desktop
    }
  }

  // Set up pagination
  function setupPagination(totalReviews, perPage = null) {
    // If perPage is not provided, calculate it dynamically
    if (perPage === null) {
      perPage = getOptimalPerPage(totalReviews);
    }
    
    // Store the current perPage value globally for use in pagination clicks
    window.currentPerPage = perPage;
    const paginationContainer = document.querySelector('.t4s-custom-reviews-pagination');
    if (!paginationContainer) return;
    
    // Calculate total pages
    const totalPages = Math.ceil(totalReviews / perPage);
    
    // Get the pages container
    const pagesContainer = paginationContainer.querySelector('.t4s-pagination-pages');
    if (!pagesContainer) return;
    
    // Clear pages container
    pagesContainer.innerHTML = '';
    
    if (totalPages <= 1) {
      paginationContainer.style.display = 'none';
      return;
    } else {
      paginationContainer.style.display = 'flex';
    }
    
    // Get prev and next buttons
    const prevButton = paginationContainer.querySelector('.t4s-pagination-prev');
    const nextButton = paginationContainer.querySelector('.t4s-pagination-next');
    
    if (prevButton) {
      // Remove any existing event listeners
      prevButton.replaceWith(prevButton.cloneNode(true));
      // Get the new reference after cloning
      const newPrevButton = paginationContainer.querySelector('.t4s-pagination-prev');
      
      newPrevButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (window.currentPage > 1) {
          window.currentPage--;
          const currentReviews = getCurrentFilteredReviews();
          displayReviews(currentReviews, window.currentPage, window.currentPerPage);
          updateActivePage(window.currentPage);
          
          // Scroll to reviews summary
          scrollToReviews();
        }
      });
    }
    
    // Create an array of page numbers to display
    let pagesToShow = [1]; // Always show page 1
    
    // Add current page -2, -1, current, +1, +2 if they're not page 1
    for (let i = window.currentPage - 2; i <= window.currentPage + 2; i++) {
      if (i > 1 && i < totalPages) {
        pagesToShow.push(i);
      }
    }
    
    // Add last page if it exists and isn't already included
    if (totalPages > 1) {
      pagesToShow.push(totalPages);
    }
    
    // Sort and remove duplicates
    pagesToShow = [...new Set(pagesToShow)].sort((a, b) => a - b);
    
    // Add page buttons
    let prevPage = 0;
    for (let i = 0; i < pagesToShow.length; i++) {
      const pageNum = pagesToShow[i];
      
      // Add ellipsis if there's a gap
      if (pageNum - prevPage > 1) {
        const ellipsis = document.createElement('span');
        ellipsis.className = 't4s-pagination-ellipsis';
        ellipsis.textContent = '...';
        pagesContainer.appendChild(ellipsis);
      }
      
      // Create the page button
      const pageButton = document.createElement('button');
      pageButton.className = 't4s-pagination-page';
      if (pageNum === window.currentPage) pageButton.classList.add('active');
      pageButton.textContent = pageNum;
      pageButton.setAttribute('data-page', pageNum);
      
      pageButton.addEventListener('click', function(e) {
        e.preventDefault();
        const page = parseInt(this.getAttribute('data-page'));
        window.currentPage = page;
        const currentReviews = getCurrentFilteredReviews();
        displayReviews(currentReviews, page, window.currentPerPage || perPage);
        updateActivePage(page);
        
        // Scroll to reviews summary
        scrollToReviews();
      });
      
      pagesContainer.appendChild(pageButton);
      prevPage = pageNum;
    }
    
    if (nextButton) {
      // Remove any existing event listeners
      nextButton.replaceWith(nextButton.cloneNode(true));
      // Get the new reference after cloning
      const newNextButton = paginationContainer.querySelector('.t4s-pagination-next');
      
      newNextButton.addEventListener('click', function(e) {
        e.preventDefault();
        const totalPages = Math.ceil(getCurrentFilteredReviews().length / window.currentPerPage);
        if (window.currentPage < totalPages) {
          window.currentPage++;
          const currentReviews = getCurrentFilteredReviews();
          displayReviews(currentReviews, window.currentPage, window.currentPerPage);
          updateActivePage(window.currentPage);
          
          // Scroll to reviews summary
          scrollToReviews();
        }
      });
    }
  }

  // Helper function to scroll to reviews summary
  function scrollToReviews() {
       // Use the shared utility function to handle the sticky header
    T4SThemeSP.HeaderUtils.hideAndRestoreStickyHeader(3000);
    const summarySection = document.querySelector('.t4s-custom-reviews-filter');
    if (summarySection) {
      summarySection.scrollIntoView({ behavior: 'smooth' });
    }
  }
  
  // Helper function to get the current filtered reviews
  function getCurrentFilteredReviews() {
    return window.currentFilteredReviews || Object.values(window.allReviews);
  }
  
  // Helper function to get active product filter
  function getActiveProductFilter() {
    // First check for product list filter
    const productListFilter = document.getElementById('product-list-filter');
    if (productListFilter && productListFilter.value !== 'all') {
      return productListFilter.value;
    }
    
    // Fall back to button-based product filter
    const activeButton = document.querySelector('.t4s-filter-btn.active');
    return activeButton ? activeButton.getAttribute('data-filter') : 'all';
  }

  // Update active page in pagination
  function updateActivePage(page) {
    const pageButtons = document.querySelectorAll('.t4s-pagination-page');
    pageButtons.forEach(button => {
      button.classList.remove('active');
      if (parseInt(button.getAttribute('data-page')) === page) {
        button.classList.add('active');
      }
    });
  }
  
  // Function to set up custom dropdown functionality
  function setupCustomDropdown(wrapperId, displayId, dropdownId, selectId) {
    const wrapper = document.getElementById(wrapperId);
    const display = document.getElementById(displayId);
    const dropdown = document.getElementById(dropdownId);
    const select = document.getElementById(selectId);
    const options = dropdown.querySelectorAll('.t4s-dropdown-option');
    
    if (!wrapper || !display || !dropdown || !select) return;
    
    // Toggle dropdown when clicking the display element
    display.addEventListener('click', function() {
      wrapper.classList.toggle('open');
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(event) {
      if (!wrapper.contains(event.target)) {
        wrapper.classList.remove('open');
      }
    });
    
    // Handle option selection
    options.forEach(option => {
      option.addEventListener('click', function() {
        const value = this.getAttribute('data-value');
        let displayContent;
        
        // Special handling for rating filter with star images
        if (selectId === 'rating-filter' && value !== 'all') {
          // If this is a rating option with stars
          const img = this.querySelector('img');
          if (img) {
            // Clone the image for the display
            displayContent = img.cloneNode(true);
            // Clear any existing content
            display.innerHTML = '';
            // Add the image to the display
            display.appendChild(displayContent);
          } else {
            display.textContent = this.textContent;
          }
        } else if (selectId === 'product-list-filter') {
          const tsCustomerReviewFilterButtons=document.querySelector('.t4s-custom-reviews-filter-buttons')
          // For regular text options
          if (value !== 'all'){
            display.querySelector('.t4s-select-display-text').textContent = this.textContent;
            // hidden the product filter buttons
            tsCustomerReviewFilterButtons.style.display='none'
          }else{
            display.querySelector('.t4s-select-display-text').textContent = 'Products';
            // show the product filter buttons
            tsCustomerReviewFilterButtons.style.display='flex'
            const productFilterButtons = document.querySelectorAll('.t4s-filter-btn');
            productFilterButtons.forEach(button => {
              if(button.dataset.filter === 'all'){
                button.classList.add('active');
              }
            });
          }
        } else {
          // For regular text options
          display.textContent = this.textContent;
        }
        
        // Update selected option in dropdown
        options.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');
        
        // Update the hidden select element
        select.value = value;
        
        // Trigger change event on select
        const event = new Event('change', { bubbles: true });
        select.dispatchEvent(event);
        
        // Close dropdown
        wrapper.classList.remove('open');
      });
    });
  }
});
